import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useCart } from '../../context/CartContext.jsx';
import { useNavigate } from 'react-router-dom';
import './Checkout.scss';

const Checkout = () => {
    const { cartItems, cartTotal, clearCart } = useCart();
    const navigate = useNavigate();
    const [orderPlaced, setOrderPlaced] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Simulate order placement
        setOrderPlaced(true);
        setTimeout(() => {
            clearCart();
            navigate('/');
        }, 3000);
    };

    if (orderPlaced) {
        return (
            <div className="order-success-page sectionPadding">
                <Container className="text-center">
                    <div className="success-animation mb-4" data-aos="zoom-in">
                        <i className="fas fa-check-circle text-success" style={{fontSize: '100px'}}></i>
                    </div>
                    <h2 className="title-xl mb-3">Order Placed Successfully!</h2>
                    <p className="mb-4">Thank you for shopping with V2 Collection. Redirecting you to home...</p>
                </Container>
            </div>
        );
    }

    return (
        <div className="checkout-page sectionPadding">
            <Container>
                <Row className="g-5">
                    <Col lg={7} data-aos="fade-right">
                        <div className="checkout-form-wrapper info-card p-4">
                            <h4 className="title-md fw-bold mb-4">SHIPPING INFORMATION</h4>
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6} className="mb-3">
                                        <Form.Group controlId="firstName">
                                            <Form.Label>First Name</Form.Label>
                                            <Form.Control type="text" placeholder="First Name" required />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <Form.Group controlId="lastName">
                                            <Form.Label>Last Name</Form.Label>
                                            <Form.Control type="text" placeholder="Last Name" required />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control type="email" placeholder="email@example.com" required />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="address">
                                    <Form.Label>Street Address</Form.Label>
                                    <Form.Control type="text" placeholder="Address" required />
                                </Form.Group>
                                <Row>
                                    <Col md={6} className="mb-3">
                                        <Form.Group controlId="city">
                                            <Form.Label>City</Form.Label>
                                            <Form.Control type="text" placeholder="City" required />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <Form.Group controlId="zip">
                                            <Form.Label>ZIP Code</Form.Label>
                                            <Form.Control type="text" placeholder="ZIP" required />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                
                                <h4 className="title-md fw-bold mt-4 mb-4">PAYMENT METHOD</h4>
                                <div className="payment-options d-flex gap-4 mb-4">
                                    <div className="payment-option border rounded p-3 text-center flex-grow-1 cursor-pointer">
                                        <i className="fas fa-credit-card d-block mb-2 fs-3"></i>
                                        <span>Credit Card</span>
                                    </div>
                                    <div className="payment-option border rounded p-3 text-center flex-grow-1 cursor-pointer">
                                        <i className="fab fa-paypal d-block mb-2 fs-3"></i>
                                        <span>PayPal</span>
                                    </div>
                                </div>

                                <Button type="submit" className="dBtn btnPrimary w-100 py-3 mt-2">
                                    PLACE ORDER (${cartTotal.toFixed(2)})
                                </Button>
                            </Form>
                        </div>
                    </Col>

                    <Col lg={5} data-aos="fade-left">
                        <div className="order-summary-card info-card p-4">
                            <h4 className="title-sm fw-bold mb-4">YOUR ORDER</h4>
                            <div className="checkout-items mb-4">
                                {cartItems.map(item => (
                                    <div key={`${item.id}-${item.size}`} className="checkout-item d-flex justify-content-between mb-3">
                                        <div className="d-flex gap-3">
                                            <div className="checkout-img-wrap" style={{width: '50px', height: '60px'}}>
                                                <img src={item.productImage} alt={item.title} className="w-100 h-100 object-fit-cover rounded" />
                                            </div>
                                            <div>
                                                <p className="mb-0 fw-bold">{item.title}</p>
                                                <p className="mb-0 text-muted small">{item.size} x {item.quantity}</p>
                                            </div>
                                        </div>
                                        <span className="fw-bold">${(parseFloat(item.price) * item.quantity).toFixed(2)}</span>
                                    </div>
                                ))}
                            </div>
                            <hr />
                            <div className="summary-row d-flex justify-content-between mb-2">
                                <span>Subtotal</span>
                                <span>${cartTotal.toFixed(2)}</span>
                            </div>
                            <div className="summary-row d-flex justify-content-between mb-2">
                                <span>Shipping</span>
                                <span className="text-success">FREE</span>
                            </div>
                            <div className="summary-row total-row-checkout d-flex justify-content-between mt-3">
                                <span className="fw-bold fs-5">TOTAL</span>
                                <span className="fw-bold fs-5">${cartTotal.toFixed(2)}</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Checkout;
